
import { CSSProperties } from 'react';
export const DROPDOWN_STYLES = {
  // ===== TruncatedTooltip Component =====
  truncatedTooltipText: {
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#0F172A',
    whiteSpace: 'nowrap' as const,
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis',
    maxWidth: '220px',
    display: 'block',
  } as CSSProperties,
  // Dropdown container principal
  dropdownContainer: {
    position: 'fixed' as const,
    zIndex: 1300,
    background: 'white',
    borderRadius: 14,
    boxShadow: '0 8px 32px rgba(44, 62, 80, 0.10)',
    border: '1.5px solid #E0E6ED',
    padding: 0,
    minWidth: 320,
  } as CSSProperties,

  // Sección de búsqueda
  searchSection: {
    width: 320,
    height: 80,
    opacity: 1,
    padding: '16px',
    background: 'white',
    borderTopLeftRadius: 14,
    borderTopRightRadius: 14,
  } as CSSProperties,

  // Divisor
  divider: {
    height: 1.5,
    background: '#E0E6ED',
  } as CSSProperties,

  // Sección de contenido
  contentSection: {
    width: 320,
    background: '#fff',
    overflow: 'hidden' as const,
    borderBottomLeftRadius: 14,
    borderBottomRightRadius: 14,
  } as CSSProperties,

  // Estado vacío
  emptyState: {
    padding: 20,
    textAlign: 'center' as const,
    background: 'transparent',
  } as CSSProperties,

  emptyStateTitle: {
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    fontSize: '14px',
    fontStyle: 'normal' as const,
    lineHeight: '20px',
    color: '#475569',
    marginBottom: 8,
  } as CSSProperties,

  emptyStateText: {
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    fontSize: '12px',
    fontStyle: 'normal' as const,
    lineHeight: '26px',
    color: '#475569',
    letterSpacing: '0.2px',
  } as CSSProperties,

  emptyStateLink: {
    color: '#2563eb',
    textDecoration: 'underline',
  } as CSSProperties,

  // Espaciador
  spacer: {
    height: 16,
    background: 'transparent',
  } as CSSProperties,

  // ===== SearchInput Component =====
  searchInputContainer: {
    position: 'relative' as const,
    width: '100%',
    height: 48,
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,

  searchInputIconWrapper: {
    position: 'absolute' as const,
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 24,
    height: 24,
    color: '#b0b8c1',
    pointerEvents: 'none' as const,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,

  // ===== DropdownTrigger Component =====
  triggerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'auto',
    height: 48,
    opacity: 1,
    gap: '12px',
    color: '#23272f',
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'default',
  } as CSSProperties,

  triggerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
    minWidth: 0,
    cursor: 'pointer',
  } as CSSProperties,

  triggerTitle: {
    fontFamily: 'Ubuntu',
    fontWeight: 700,
    fontSize: '16px',
    color: '#64748B',
    lineHeight: '24px',
    display: 'inline-flex',
    width: 'auto',
  } as CSSProperties,

  triggerSubtitle: {
    color: '#64748B',
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: 2,
    maxWidth: 260,
    whiteSpace: 'nowrap' as const,
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis',
  } as CSSProperties,

  triggerButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    padding: 0,
    marginLeft: 12,
    transition: 'transform 0.2s',
    outline: 'none',
  } as CSSProperties,

  triggerIcon: {
    filter: 'brightness(0.3)',
    transition: 'filter 0.2s ease',
  } as CSSProperties,

  // ===== MerchantItem Component =====
  merchantItemBase: {
    display: 'flex',
    alignItems: 'flex-start',
    width: 320,
    height: 52,
    opacity: 1,
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '16px',
    paddingRight: '16px',
    gap: '8px',
    fontWeight: 400,
    color: '#23272f',
    cursor: 'pointer',
    borderLeft: '3px solid transparent',
    borderRadius: 0,
    transition: 'background 0.15s',
  } as CSSProperties,

  merchantItemIcon: {
    marginRight: 12,
    marginTop: 2,
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,

  merchantItemContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    minWidth: 0,
  } as CSSProperties,

  merchantItemName: {
    fontFamily: 'Ubuntu',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#0F172A',
    whiteSpace: 'nowrap' as const,
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis',
  } as CSSProperties,

  merchantItemDetails: {
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.2px',
    color: '#475569',
    marginTop: 1,
  } as CSSProperties,

  // ===== SubItem Component =====
  subItemBase: {
    display: 'flex',
    alignItems: 'flex-start',
    width: 320,
    height: 52,
    opacity: 1,
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '16px',
    paddingRight: '16px',
    gap: '8px',
    fontWeight: 400,
    color: '#23272f',
    padding: '4px 18px 0px 20px',
    cursor: 'pointer',
    borderLeft: 'none',
    borderRadius: 0,
    transition: 'background 0.15s',
    borderBottom: 'none',
  } as CSSProperties,

  subItemSpacer: {
    marginRight: 12,
    width: 22,
    height: 22,
    display: 'inline-block',
  } as CSSProperties,

  subItemContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    minWidth: 0,
  } as CSSProperties,

  subItemDetails: {
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: '#6c7580',
    letterSpacing: '0.2px',
    marginTop: 1,
  } as CSSProperties,

  // ===== SubItemList Component =====
  subItemListContainer: {
    maxHeight: 416,
    marginLeft: 0,
    overflowX: 'hidden' as const,
  } as CSSProperties,

  // ===== MerchantList Component =====
  merchantListContainer: {
    // Container sin estilos específicos, solo wrapper semántico
  } as CSSProperties,

  merchantListGroup: {
    // Grupo de merchant + subitems sin estilos específicos
  } as CSSProperties,
} as const;
